<!--spinner -->
<!-- Anchor per toolbar.js: querySelector('header') al DOMContentLoaded, prima del render dello shell -->
<header class="ecomic-toolbar-anchor" aria-label="Barra superiore Ecomic"></header>
@if (loader.isLoading()) {
  <div class="global-loader">
    <div>
      <div class="spinner"></div>
    </div>
  </div>
}
<router-outlet></router-outlet>
